import api from '@/js/services/axios'

/**
 * API for membership assignments (participant–org agreements) in the memberships domain.
 * Backend: GET/POST /api/private/v1/org/{orgId}/memberships
 * Per-participant operations (update, stop, delete, paid, invoice) use TParticipantRepository.
 */
const BASE = 'private/v1/org/{orgId}/memberships'

export default {
  /**
   * Get all memberships for the organization with optional filtering
   * @param {string} startDate - Optional start date (ISO format)
   * @param {string} endDate - Optional end date (ISO format)
   * @param {boolean} onlyActive - If true, only return active/usable memberships
   * @returns {Promise<Array>} List of membership assignments
   */
  getAllMemberships: async (startDate = null, endDate = null, onlyActive = false) => {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams()
      if (startDate) params.append('start_date', startDate)
      if (endDate) params.append('end_date', endDate)
      params.append('only_active', onlyActive)
      api.get(BASE + '?' + params.toString())
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  /**
   * Create a new membership assignment (assign template to participant)
   * @param {Object} membershipData - { r_membership_template_id, start_date, r_organization_participant_id } or backend contract
   * @returns {Promise<Object>} Created membership assignment
   */
  createMembership: async (membershipData) => {
    return new Promise((resolve, reject) => {
      api.post(BASE, membershipData)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }
}
